import { render, staticRenderFns } from "./BatchDetailsSection.template.vue?vue&type=template&id=d0dd20dc&scoped=true&"
var script = {}
import style0 from "./BatchDetailsSection.template.vue?vue&type=style&index=0&id=d0dd20dc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0dd20dc",
  null
  
)

export default component.exports